export enum ContentType {
  Follawed = "follawed",
  AllMatch = "allMatch",
}
